export default __webpack_public_path__ + "static/media/cabourg14.f5b155c9.jpg";